/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SuggestedSearch } from './SuggestedSearch';
import {
    SuggestedSearchFromJSON,
    SuggestedSearchFromJSONTyped,
    SuggestedSearchToJSON,
    SuggestedSearchToJSONTyped,
} from './SuggestedSearch';

/**
 * Response to the /suggested_searches/{suggested_search_id}
 * @export
 * @interface SuggestedSearchResponse
 */
export interface SuggestedSearchResponse {
    /**
     * 
     * @type {SuggestedSearch}
     * @memberof SuggestedSearchResponse
     */
    suggestedSearch: SuggestedSearch;
}

/**
 * Check if a given object implements the SuggestedSearchResponse interface.
 */
export function instanceOfSuggestedSearchResponse(value: object): value is SuggestedSearchResponse {
    if (!('suggestedSearch' in value) || value['suggestedSearch'] === undefined) return false;
    return true;
}

export function SuggestedSearchResponseFromJSON(json: any): SuggestedSearchResponse {
    return SuggestedSearchResponseFromJSONTyped(json, false);
}

export function SuggestedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestedSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestedSearch': SuggestedSearchFromJSON(json['suggested_search']),
    };
}

export function SuggestedSearchResponseToJSON(json: any): SuggestedSearchResponse {
    return SuggestedSearchResponseToJSONTyped(json, false);
}

export function SuggestedSearchResponseToJSONTyped(value?: SuggestedSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'suggested_search': SuggestedSearchToJSON(value['suggestedSearch']),
    };
}

